import api from "../http-request";

// [POST METHOD]
export const getAndCreateRentalSpaceView = async (data) =>
  api.post(`api/rental-spaces/view`, data);

// [GET METHOD]
export const getRentalSpaceFavorite = async (rentalSpaceId) =>
  api.get(`api/rental-spaces/favorite/${rentalSpaceId}`);
